import { FormattedMessage } from 'react-intl';
import React from 'react';
import { CardWidgetField } from '../CardFormWL.types';

const CARD_PREFIX = 'paymentMethod.description.CARD';
const LABEL_PREFIX = `${CARD_PREFIX}.field.label`;

function CardFormTemplate() {
  return (
    <div className="container" id="card-component__wl-main">
      <div className="row">
        <span className="label card-component__wl-label-holdername">
          <FormattedMessage id={`${LABEL_PREFIX}.holdername`} />
        </span>
        <input className="col-12" id={CardWidgetField.HOLDER_NAME} readOnly />
      </div>
      <div className="row">
        <span className="label card-component__wl-label-cardnumber">
          <FormattedMessage id={`${LABEL_PREFIX}.cardnumber`} />
        </span>
        <input className="col-12" id={CardWidgetField.CARD_NUMBER} readOnly />
      </div>
      <div className="row one-line">
        <div className="card-component__wl-input-expiration">
          <span className="label card-component__wl-label-expiration">
            <FormattedMessage id={`${LABEL_PREFIX}.expiration`} />
          </span>
          <input id={CardWidgetField.EXPIRATION} readOnly />
        </div>
        <div className="card-component__wl-input-cvc">
          <span className="label card-component__wl-label-cvc">
            <FormattedMessage id={`${LABEL_PREFIX}.cvc`} />
          </span>
          <input id={CardWidgetField.CVC} readOnly />
        </div>
      </div>
    </div>
  );
}

export default CardFormTemplate;
